import { NavLink } from 'react-router-dom';

import { cn } from '../../lib/cn';
import { usePlayerNav } from './use-player-nav';

/**
 * Mobile tab bar (TZ §39). Every tab is a 44px+ target and the bar respects the
 * iOS home-indicator inset so the last row of content stays reachable.
 */
const TAB_GRID_CLASS: Record<number, string> = {
  6: 'grid-cols-6',
  7: 'grid-cols-7',
};

export function BottomNav() {
  const nav = usePlayerNav();
  const gridClass = TAB_GRID_CLASS[nav.length] ?? 'grid-cols-6';

  return (
    <nav
      aria-label="Основная навигация"
      className="safe-bottom fixed inset-x-0 bottom-0 z-40 border-t border-line bg-surface lg:hidden"
    >
      <ul className={cn('grid h-[76px] items-stretch', gridClass)}>
        {nav.map(({ to, label, icon: Icon, end }) => (
          <li key={to} className="min-w-0">
            <NavLink
              to={to}
              end={end}
              className={({ isActive }) =>
                cn(
                  'flex h-full min-h-11 flex-col items-center justify-center gap-1 px-0.5',
                  'text-[0.625rem] font-semibold transition-colors',
                  isActive ? 'text-brand' : 'text-ink-muted hover:text-ink',
                )
              }
            >
              <Icon className="size-5" />
              <span className="max-w-full truncate">{label}</span>
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
